<template>
  <!--关联新闻页面  -->
  <div class="detail">
    <div class="detail_box">
      <el-card>
        <div>
          <i class="el-icon-search"></i>
          <span>筛选搜索</span>
        </div>
        <div style="margin-top: 15px">
          <el-form
            :inline="true"
            label-width="120px"
            ref="search"
            size="small"
            :label-position="labelPosition"
          >
            <el-form-item label="标题">
              <el-input
                placeholder="请输入标题"
                v-model="listQuery.title"
              ></el-input>
            </el-form-item>
            <el-form-item label="发布位置">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="listQuery.fbposition"
                :disabled="true"
              >
                <el-option
                  :key="item.id"
                  :label="item.menuName"
                  :value="item.id"
                  v-for="item in positions"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保存时间">
              <el-date-picker
                clearable
                end-placeholder="结束日期"
                range-separator="至"
                size="small"
                start-placeholder="开始日期"
                type="daterange"
                v-model="listQuery.searchTime"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="状态">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="listQuery.status"
                :disabled="true"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in newsStatus"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="listQuery.sortTime"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in sortData"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否上首页">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="listQuery.homeIn"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in homeInOn"
                ></el-option>
              </el-select>
            </el-form-item>
            <div>
              <el-form-item>
                <el-button
                  @click="searchNewsList()"
                  size="mini"
                  style="float: right; margin-left: 50px"
                  type="primary"
                  v-if="menuPerm('aid:add')"
                  >查询</el-button
                >
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-card>
      <el-card>
        <el-table
          :data="list"
          @selection-change="handleSelectionChange"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          :header-cell-style="getRowClass"
        >
          <!-- 多选-->
          <el-table-column label="标题" prop="newsTitle"></el-table-column>
          <el-table-column label="发布位置" prop="menuName"></el-table-column>

          <el-table-column label="送审时间" prop></el-table-column>
          <el-table-column
            label="审核时间"
            prop="createTimestamp"
          ></el-table-column>
          <el-table-column label="权重" prop="sort"></el-table-column>

          <el-table-column label="状态" prop="examineStatus">
            <template slot-scope="scope">
              <span v-if="scope.row.examineStatus == 2">未提交审核</span>
              <span v-if="scope.row.examineStatus == 3">审核中</span>
              <span v-if="scope.row.examineStatus == 4">审核未通过</span>
              <span v-if="scope.row.examineStatus == 1">审核通过</span>
              <span v-if="scope.row.examineStatus == 5">下架</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
          >
            <template slot-scope="{ row }">
              <el-button
                @click="getAddPoor(row.id)"
                size="mini"
                type="primary"
                v-if="menuPerm('aid:add')"
                >添加</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="currentPage"
          :page-size="pagesize"
          :page-sizes="[5, 10, 15]"
          :total="totalCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          style="margin-top: 20px; margin-left: 10px"
        ></el-pagination>
      </el-card>
    </div>

    <!-- 扶贫添加弹出框 -->
    <a-modal title :visible="addOpen" @cancel="addCancel" :footer="null">
      <el-form
        :inline="true"
        size="small"
        ref="formName"
        :model="addPoor"
        :rules="poorRule"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="扶贫协作和对口支援(天津)" prop="aidAreaList">
              <el-select
                v-model="addPoor.aidAreaList"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in aidAreaData"
                  :key="item.enumeration"
                  :label="item.name"
                  :value="item.enumeration"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="扶贫协作和对口支援(西部)"
              prop="aidAreaGansuList"
            >
              <el-cascader
                :options="options"
                :props="props"
                clearable
                collapse-tags
                v-model="addPoor.aidAreaGansuList"
                ref="demoCascader"
                @change="xibuChange"
              ></el-cascader>
              <!-- <el-select
                placeholder="请选择"
                v-model="addPoor.aidAreaGansuList"
                multiple
                clearable
                @change="allChange"
              >
                <el-option
                  v-for="item in xibuAreaData"
                  :key="item.enumeration"
                  :label="item.name"
                  :value="item.enumeration"
                ></el-option>
              </el-select> -->
              <!-- <el-select
                multiple
                collapse-tags
                v-model="selectedArray"
                @change="changeSelect"
                placeholder="请选择"
              >
                <el-checkbox v-model="checked" @change="selectAll"
                  >全选</el-checkbox
                >
                <el-option
                  v-for="(item, index) in xibuAreaData"
                  :key="index"
                  :label="item.name"
                  :value="item.enumeration"
                ></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <!-- <el-row>
            <el-cascader
              :options="options"
              :props="props"
              clearable
              collapse-tags
              v-model="addPoor.aidAreaGansuList"
              ref="demoCascader"
              @change="xibuChange"
            ></el-cascader>
          </el-row> -->
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="帮扶维度" prop="aidType">
              <el-select
                placeholder="请选择"
                v-model="addPoor.aidType"
                clearable
              >
                <el-option
                  v-for="item in aidTypeData"
                  :key="item.enumeration"
                  :label="item.name"
                  :value="item.enumeration"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="历程" prop="aidDate">
              <el-date-picker
                v-model="addPoor.aidDate"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col style="margin: 10px 0 15px 10px">
            <a-checkbox @change="zhanGuan"> 消费扶贫 </a-checkbox>
            <a-checkbox @change="shiXian" style="margin-left: 20px">
              美好视线
            </a-checkbox>
            <a-checkbox @change="anLi" style="margin: 0 20px">
              经典案例
            </a-checkbox>

            <a-checkbox @change="yaoWen"> 扶贫要闻 </a-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <el-button
                @click="addSubmit('formName')"
                size="mini"
                type="primary"
                v-if="menuPerm('aid:add')"
                >添加</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      props: { multiple: true, emitPath: false },
      options: [
        {
          value: "1",
          label: "全部",
          children: [],
        },
      ],
      checked: false,
      selectedArray: [],
      addOpen: false, //扶贫添加弹框
      poorAddId: "", //扶贫添加id
      // 添加扶贫数据
      addPoor: {
        aidType: "", //帮扶维度
        aidAreaList: [], //扶贫区域
        modelPower: "", //典范力量
        aidDate: "", //扶贫日期
        isFocusNews: "", //是否扶贫要闻
        isFineNews: "", //美好视线
        isClassicNews: "", //经典案例
        isPovertyNews: "", //消费扶贫
        aidAreaGansuList: "",
      },

      poorRule: {
        aidType: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        aidAreaList: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        aidAreaGansuList: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        isFocusNews: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        aidDate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },

      //   下拉框的数据：
      aidTypeData: "", //帮扶维度下拉框数据
      aidAreaData: "", //扶贫区域下拉框数据
      modelPowerData: "", //典范力量下拉框数据
      xibuAreaData: "", //西部区域下拉框
      labelPosition: "right", //表格样式
      positions: "", //发布位置
      //查询条件:
      listQuery: {
        title: "", //标题
        searchTime: "", //保存时间
        fbposition: "15", //发布位置
        status: "1", //状态
        sortTime: "", //排序
        homeIn: "", //是否上首页
      },
      startTime: "", //开始时间
      endTime: "", //结束时间
      //排序：
      sortData: [
        {
          value: "create_date",
          label: "创建时间",
        },
        {
          value: "sort",
          label: "权重",
        },
      ],
      //是否上首页：
      homeInOn: [
        {
          value: "0",
          label: "不上首页",
        },
        {
          value: "1",
          label: "上首页",
        },
      ],
      //状态：
      newsStatus: [
        {
          value: "2",
          label: "未提交审核",
        },
        {
          value: "3",
          label: "审核中",
        },
        {
          value: "4",
          label: "审核未通过",
        },
        {
          value: "1",
          label: "审核通过",
        },
        {
          value: "5",
          label: "下架",
        },
      ],
      //是否扶贫要闻
      FocusNewsData: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      list: [], //新闻数据
      currentPage: 1, //初始页
      totalCount: 0,
      pagesize: 10, //每页数据
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%";
      } else {
        return "";
      }
    },
    //分页
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
      // console.log(this.pagesize); //每页下拉显示数据
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
      // console.log(this.currentPage); //点击第几页
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //发布位置
    getPosition() {
      this.getAxios("/menu/list").then((res) => {
        if (res.success == true) {
          this.positions = res.content;
        }

        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    changeTianJin(value) {
      this.addPoor.aidAreaList.push(value);
    },
    allChange() {},
    //新闻列表
    getList() {
      var title = this.listQuery.title,
        issuePos = this.listQuery.fbposition, //发布位置
        saveTime = this.listQuery.searchTime, //保存时间
        status = this.listQuery.status; //状态
      if (this.listQuery.searchTime == null) {
        this.startTime = "";
        this.endTime = "";
      } else {
        (this.startTime = new Date(saveTime[0]).getTime() / 1000),
          (this.endTime = new Date(saveTime[1]).getTime() / 1000);
      }
      this.postAxios("/news/listAllNewsWhithoutRole", {
        pageNum: this.currentPage,
        pageSize: 10,
        newsTitle: title, //
        menuId: issuePos, //发布位置
        // expectMenuId: expectPos, //期望位置

        examineStatus: status,
        createTimestampStart: this.startTime, // 时间范围查询开始时间
        createTimestampEnd: this.endTime, // 时间范围查询结束时间
      }).then((res) => {
        if (res.success == true) {
          this.list = res.content;
          this.totalCount = res.totalCount;

          // 时间戳转时间
          this.list.map((i, index) => {
            if (i.examineStatus == "1") {
              this.examineStatus = "审核通过";
            } else if (i.examineStatus == "2") {
              this.examineStatus = "未提交审核";
            } else if (i.examineStatus == "3") {
              this.examineStatus = "审核中";
            } else if (i.examineStatus == "4") {
              this.examineStatus = "审核未通过";
            } else {
              this.examineStatus = "下架";
            }
            if (i.reviewTimestamp != null) {
              var timeTrans = new Date(parseInt(i.reviewTimestamp) * 1000);
              let reviewTimestamp = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });
              this.$set(this.list[index], `createTimestamp`, reviewTimestamp);
            } else {
              this.$set(this.list[index], `createTimestamp`, "");
            }

            if (i.sort != null && i.sort != 0) {
              var timeTrans = new Date(parseInt(i.sort) * 1000);
              let reviewTimestampsd = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });

              this.$set(this.list[index], `sort`, reviewTimestampsd);
            } else {
              this.$set(this.list[index], `sort`, "");
            }
          });
        }

        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //点击查询功能
    searchNewsList() {
      this.currentPage = 1;
      var title = this.listQuery.title,
        issuePos = this.listQuery.fbposition, //发布位置
        saveTime = this.listQuery.searchTime, //保存时间
        status = this.listQuery.status; //状态
      if (this.value1 == null) {
        this.startTime = "";
        this.endTime = "";
      } else {
        (this.startTime = new Date(saveTime[0]).getTime() / 1000),
          (this.endTime = new Date(saveTime[1]).getTime() / 1000);
      }
      this.postAxios("/news/listAllNewsWhithoutRole", {
        pageNum: 1,
        pageSize: 10,
        newsTitle: title, //
        menuId: issuePos, //发布位置
        examineStatus: status,
        createTimestampStart: this.startTime, // 时间范围查询开始时间
        createTimestampEnd: this.endTime, // 时间范围查询结束时间
        sortField: this.listQuery.sortTime, //排序权重
        isRecommend: this.listQuery.homeIn, //1上首页推荐，否则传空
      }).then((res) => {
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }

        if (res.success == true) {
          this.list = res.content;
          this.totalCount = res.totalCount;

          // 时间戳转时间
          this.list.map((i, index) => {
            if (i.examineStatus == "1") {
              this.examineStatus = "审核通过";
            } else if (i.examineStatus == "2") {
              this.examineStatus = "未提交审核";
            } else if (i.examineStatus == "3") {
              this.examineStatus = "审核中";
            } else if (i.examineStatus == "4") {
              this.examineStatus = "审核未通过";
            } else {
              this.examineStatus = "下架";
            }
            if (i.reviewTimestamp != null) {
              var timeTrans = new Date(parseInt(i.reviewTimestamp) * 1000);
              let reviewTimestamp = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });
              this.$set(this.list[index], `createTimestamp`, reviewTimestamp);
            } else {
              this.$set(this.list[index], `createTimestamp`, "");
            }

            if (i.sort != null && i.sort != 0) {
              var timeTrans = new Date(parseInt(i.sort) * 1000);
              let revieTime = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });

              this.$set(this.list[index], `sort`, revieTime);
            } else {
              this.$set(this.list[index], `sort`, "");
            }
          });
        }
      });
    },

    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //新闻添加扶贫列表：
    getAddPoor(ids) {
      this.poorAddId = ids;
      this.addOpen = true;

      this.$nextTick(() => {
        this.$refs["formName"].clearValidate(); // 清除整个表单的校验
        this.$refs["formName"].resetFields(); // 清除整个表单的内容
      });
    },
    // 扶贫要闻
    yaoWen(e) {
      var val = e.target.checked;
      if (val == true) {
        this.addPoor.isFocusNews = 1;
      } else {
        this.addPoor.isFocusNews = "";
      }
    },
    // 经典案例
    anLi(e) {
      var val = e.target.checked;
      if (val == true) {
        this.addPoor.isClassicNews = 1;
      } else {
        this.addPoor.isClassicNews = "";
      }
    },
    // 美好视线
    shiXian(e) {
      var val = e.target.checked;
      if (val == true) {
        this.addPoor.isFineNews = 1;
      } else {
        this.addPoor.isFineNews = "";
      }
    },
    // 消费扶贫
    zhanGuan(e) {
      var val = e.target.checked;
      if (val == true) {
        this.addPoor.isPovertyNews = 1;
      } else {
        this.addPoor.isPovertyNews = "";
      }
    },
    // 扶贫添加弹框确认
    addSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/aidNews/insert", {
            newsId: this.poorAddId, //新闻 id
            aidDate: this.formatDateTime(this.addPoor.aidDate), //扶贫时间
            aidType: this.addPoor.aidType, //帮扶维度
            aidAreaList: this.addPoor.aidAreaList, //扶贫区域
            isFocusNews: this.addPoor.isFocusNews.toString(), // 是否扶贫要闻
            isPovertyNews: this.addPoor.isPovertyNews.toString(), //消费扶贫
            isFineNews: this.addPoor.isFineNews.toString(), //美好视线
            isClassicNews: this.addPoor.isClassicNews.toString(), //经典案例
            aidAreaGansuList: this.addPoor.aidAreaGansuList,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("添加成功！");
              this.$refs["formName"].clearValidate(); // 清除整个表单的校验
              this.$refs["formName"].resetFields(); // 清除整个表单的内容
              this.addOpen = false;
              this.$router.push({ path: "/poor" }); //返回扶贫列表
            } else if (res.success == false) {
              this.$message.error(res.message);
              this.$refs["formName"].clearValidate(); // 清除整个表单的校验
              this.$refs["formName"].resetFields(); // 清除整个表单的内容
              this.addPoor.isFocusNews = [];
              this.addPoor.isPovertyNews = [];
              this.addPoor.isFineNews = [];
              this.addPoor.isClassicNews = [];
              this.addOpen = false;
              this.getList();
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    // 扶贫添加弹框取消
    addCancel() {
      this.addOpen = false;
    },
    // 帮扶维度下拉框
    getaidType() {
      this.getAxios(`/dic/list/aidType`, {}).then((res) => {
        if (res.success == true) {
          this.aidTypeData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //扶贫区域下拉框
    getaidArea() {
      this.getAxios(`/dic/list/aidArea`, {}).then((res) => {
        if (res.success == true) {
          this.aidAreaData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //西部区域下拉框
    getxibuArea() {
      this.getAxios("/dic/list/xibuquxian").then((res) => {
        if (res.success == true) {
          this.xibuAreaData = res.content;
          this.xibuAreaData.map((i) => {
            this.options[0].children.push({
              value: i.enumeration,
              label: i.name,
            });
          });
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
  },
  created() {
    this.getPosition(); //发布位置
    this.getList(); //获取新闻数据

    this.getaidType(); //帮扶维度下拉框
    this.getaidArea(); //扶贫区域下拉框
    this.getxibuArea(); //西部区域下拉框
  },
};
</script>
<style scoped lang="less">
.detail {
  width: 100%;
  height: 100%;
  .detail_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    .el-card {
      margin-top: 20px;
      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
      }
    }
  }
}
</style>